module.exports = __webpack_public_path__ + "static/media/backArrow.a526f902.svg";